<template>
  <div class="customer-filter" style="height: 600px !important; margin-bottom: 8px">
    <a-row>
      <a-col :span="19">
        <a-form-model layout="inline" :form="filterForm" :model="filterForm">
          <a-form-model-item label="名称">
            <a-input v-model="filterForm.name" allow-clear placeholder="用例名称" class="form-model-item" style="width: 150px" @change="onSearch" />
          </a-form-model-item>
          <a-form-model-item label="测试结果">
            <a-select v-model="filterForm.result" mode="multiple" allow-clear placeholder="测试结果" style="width: 150px" @change="onSearch">
              <a-select-option v-for="(item, index) in testCaseResults" :key="index" :value="item.value">
                <a-tag v-if="item.value !== 5" :color="item.color">{{ item.label }}</a-tag>
                <a-tag v-else :color="item.color" style="color: gray; width: 40px">{{ item.label }}</a-tag>
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="测试人员">
            <user-select v-model="filterForm.tester" mode="multiple" show-search allow-clear placeholder="测试人员" style="width: 150px" :project-id="projectId" @change="onSearch" />
          </a-form-model-item>
          <a-form-model-item label="目录">
            <a-input v-model="filterForm.module" allow-clear placeholder="目录名称" class="form-model-item" style="width: 200px" @change="onSearch" />
          </a-form-model-item>
        </a-form-model>
      </a-col>
      <a-col :span="5">
        <div style="margin-bottom: 10px; padding-right: 5px; float: right; margin-top: 3px">
          <a-button v-tc="{ name: '关联用例' }" type="primary" icon="plus" style="margin-right: 3px" @click="onAddCase()">关联用例</a-button>
          <a-button v-tc="{ name: '批量分配' }" type="primary" icon="user-add" :disabled="selectedRowKeys.length === 0" @click="assignCaseModalVisible = true">批量分配</a-button>
        </div>
      </a-col>
    </a-row>

    <a-table :scroll="{ x: 1300, y: 480 }" :pagination="pagination" :columns="columns" :data-source="tableData" :loading="loading" row-key="id" :row-selection="showRowSelection" @change="handleTableChange">
      <span slot="name" slot-scope="text, record">
        <a-tooltip placement="top" :title="record.name">
          <a v-tc="{ name: '跳转用例详情' }" class="custom-link" @click="onDetail(record)"> {{ record.name }} </a>
        </a-tooltip>
      </span>
      <span slot="id" slot-scope="text, record">
        <span>TC-{{ record.id }}</span>
      </span>
      <span slot="priority" slot-scope="text, record">
        <a-tag v-if="record.priority !== null && record.priority !== undefined" :color="casePrioritys[record.priority].color"> {{ casePrioritys[record.priority].label }} </a-tag>
        <span v-else>--</span>
      </span>
      <span slot="result" slot-scope="text, record">
        <plan-case-result-edit :disabled="resultDisabled" :plan-id="planId" :case-id="record.id" :result="record.result" @change="getCaseList" />
      </span>
      <span slot="status" slot-scope="text, record">
        <a-tag v-if="record.status" :color="caseStatus[record.status].color"> {{ caseStatus[record.status].label }} </a-tag>
        <span v-else>--</span>
      </span>
      <span slot="tags" slot-scope="text, record">
        <a-popover placement="topLeft">
          <template slot="content">
            <a-tag v-for="(tag, index) in record.tags" :key="index" color="blue">{{ tag.name }}</a-tag>
          </template>
          <template slot="title">
            <span>用例标签</span>
          </template>
          <template v-if="record.tags.length > 1">
            <a-tag v-for="(tag, index) in record.tags.slice(0, 1)" :key="index" color="blue">{{ tag.name }}</a-tag>
          </template>
          <template v-else>
            <a-tag v-for="(tag, index) in record.tags" :key="index" color="blue">{{ tag.name }}</a-tag>
          </template>
        </a-popover>
      </span>
      <span slot="tester" slot-scope="text, record">
        <user-profiles v-if="record.tester" :value="[record.tester.id]" avatar />
        <span v-else>未分配</span>
      </span>
      <span slot="path" slot-scope="text, record">
        <span style="cursor: pointer" @click="onCopy(record)">
          <template v-if="record.path.path_str">
            <template v-if="record.path.path_str.length < 13">{{ record.path.path_str }}</template>
            <template v-else>
              <a-popover placement="topLeft">
                <template slot="content">{{ record.path.path_str }}</template>
                {{ record.path.path_str.slice(0, 13) }}...
              </a-popover>
            </template>
          </template>
          <span v-else>未分配</span>
        </span>
      </span>
      <span slot="issues" slot-scope="text, record">
        <span @click="onBugListView(record)">
          <a v-for="(bugId, index) in record.issues" :key="index" class="link" style="cursor: pointer" target="_blank"> BG-{{ bugId }} </a>
        </span>
      </span>
    </a-table>
    <plan-case-detail :display="detailVisible" :plan-id="planId" :has-next="hasNext" :has-before="hasBefore" :case-id="caseId" @close="close" @next="loadNextCase" @before="loadBeforeCase" @check-requirement-review="handleCheckRequirementReview" />
    <a-modal title="请选择测试人员" :visible="assignCaseModalVisible" @ok="handleOk" @cancel="handleCancel">
      <a-form-model layout="inline">
        <a-form-model-item label="测试人员">
          <user-select v-model="tester" placeholder="测试人员" show-search show-all allow-clear style="width: 250px; margin-top: 3px" :project-id="projectId" @change="testerChange" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal title="缺陷列表" :width="960" :visible="caseIssueListVisible" @ok="caseIssueListVisible = false" @cancel="caseIssueListVisible = false">
      <plan-case-issue-list :issue-list="issueList" :plan-id="planId" :case-id="viewCaseId" @change="onIssueRemove" />
    </a-modal>
  </div>
</template>

<script>
import { issueList } from '@/api/project/issue';
import { caseStatus, casePrioritys, testCaseResults } from '@/utils/dictionary';
import { assignTestcases, getCaseIssues, planRelatedCases } from '@/api/project/testPlan';

import UserSelect from '@/components/User/UserSelect';
import PlanCaseDetail from '@/pages/project/testplan/components/PlanCaseDetail';
import PlanCaseIssueList from '@/pages/project/testplan/components/PlanCaseIssueList';
import PlanCaseResultEdit from '@/pages/project/testplan/components/PlanCaseResultEdit';

const columns = [
  {
    key: 'selection-column',
    align: 'center',
    width: 20
  },
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'key',
    width: 80,
    ellipsis: true,
    sorter: true,
    scopedSlots: { customRender: 'id' }
  },
  {
    title: '名称',
    dataIndex: 'name',
    width: 300,
    ellipsis: true,
    sorter: true,
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '测试结果',
    dataIndex: 'result',
    width: 80,
    ellipsis: true,
    sorter: true,
    scopedSlots: { customRender: 'result' }
  },
  {
    title: '测试人员',
    dataIndex: 'tester',
    width: 120,
    ellipsis: true,
    sorter: true,
    scopedSlots: { customRender: 'tester' }
  },
  {
    title: '目录',
    width: 200,
    sorter: true,
    ellipsis: true,
    dataIndex: 'module_id',
    scopedSlots: { customRender: 'path' }
  },
  {
    title: '关联的缺陷',
    dataIndex: 'issues',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'issues' }
  },
  {
    title: '优先级',
    width: 80,
    align: 'center',
    scopedSlots: { customRender: 'priority' }
  },
  {
    title: '标签',
    width: 100,
    scopedSlots: { customRender: 'tags' }
  },
  {
    title: '执行时间',
    width: 170,
    align: 'center',
    dataIndex: 'test_time',
    key: 'test_time'
  }
];
export default {
  name: 'PlanCaseList',
  components: { UserSelect, PlanCaseResultEdit, PlanCaseDetail, PlanCaseIssueList },
  props: {
    planId: {
      type: [Number, String],
      default: null
    },
    resultDisabled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      columns,
      caseStatus,
      casePrioritys,
      testCaseResults,
      tester: null,
      pagination: {
        size: 'large',
        total: 0,
        current: 1,
        pageSize: 20, // 每页中显示20条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      tableData: [],
      caseData: {},
      loading: false,
      detailVisible: false,
      caseId: null,
      projectId: parseInt(this.$route.params.project_id) || null,
      nextCaseId: null,
      hasNext: false,
      beforeCaseId: null,
      hasBefore: false,
      selectedRowKeys: [],
      filterForm: {
        name: '',
        tester: [],
        result: []
      },
      sorter: {
        sort_field: null,
        sort: null
      },
      assignCaseModalVisible: false,
      caseIssueListVisible: false,
      issueList: [],
      viewCaseId: null
    };
  },
  computed: {
    getUser() {
      return user => {
        return user === null ? '--' : user.nickname;
      };
    },
    showRowSelection() {
      return { selectedRowKeys: this.selectedRowKeys, onChange: this.onSelectChange };
    },
    link() {
      return issueId => {
        return this.$router.resolve({
          name: 'page:project:quality:issue:detail',
          params: { project_id: this.projectId },
          query: { issueId: issueId }
        }).href;
      };
    }
  },
  watch: {
    planId() {
      this.getCaseList();
    }
  },
  created() {
    if (this.planId !== null) {
      this.getCaseList();
    }
  },
  methods: {
    onBugListView(record) {
      this.issueList = [];
      this.viewCaseId = record.id;
      issueList({ project_id: this.projectId, id_list: record.issues ? record.issues : [] }).then(res => {
        this.issueList = res.data.items;
        this.caseIssueListVisible = true;
      });
    },
    onIssueRemove() {
      getCaseIssues({ plan_id: this.planId, case_id: this.viewCaseId }).then(res => {
        issueList({ project_id: this.projectId, id_list: res.data ? res.data : [] }).then(res => {
          this.issueList = res.data.items;
        });
      });
    },
    onAddCase() {
      this.$emit('add-case');
    },
    handleCancel() {
      this.assignCaseModalVisible = false;
    },
    handleOk() {
      if (!this.tester) {
        this.$message.warning('请选择测试人员');
        return;
      }
      if (!this.selectedRowKeys || this.selectedRowKeys.length === 0) {
        this.$message.warning('请选择用例');
        return;
      }
      assignTestcases({ plan_id: this.planId, tester: this.tester, cases: this.selectedRowKeys }).then(() => {
        this.$message.success('批量分配测试用例成功');
        this.assignCaseModalVisible = false;
        this.tester = null;
        this.selectedRowKeys = [];
        this.getCaseList();
      });
    },
    onCopy(record) {
      const oInput = document.createElement('input');
      if (record.path.path_str) {
        oInput.value = record.path.path_str;
      } else {
        oInput.value = '未分配';
      }

      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand('Copy'); // 执行浏览器复制命令
      oInput.remove();
      this.$message.success('复制成功');
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    testerChange(val) {
      this.tester = val;
    },
    onSearch() {
      this.pagination.current = 1;
      this.pagination.pageSize = 20;
      this.getCaseList();
    },
    // 查看用例详情
    onDetail(record) {
      this.caseId = record.id;
      this.detailVisible = true;
      this.caseData = record;
      this.findNextCase();
      this.findBeforeCase();
    },
    findNextCase() {
      const index = this.tableData.findIndex(row => row.id === this.caseId);
      if (index !== this.tableData.length - 1) {
        this.nextCaseId = this.tableData[index + 1].id;
        this.hasNext = true;
      } else {
        if (!this.hasNextPage()) {
          this.nextCaseId = null;
          this.hasNext = false;
        } else {
          this.nextCaseId = -1;
          this.hasNext = true;
        }
      }
    },
    findBeforeCase() {
      const index = this.tableData.findIndex(row => row.id === this.caseId);
      if (index !== 0 && index < this.tableData.length) {
        this.beforeCaseId = this.tableData[index - 1].id;
        this.hasBefore = true;
      } else {
        if (!this.hasBeforePage()) {
          this.beforeCaseId = null;
          this.hasBefore = false;
        } else {
          this.beforeCaseId = -1;
          this.hasBefore = true;
        }
      }
    },
    hasNextPage() {
      const pageNumber = this.pagination.current;
      const total = this.pagination.total;
      if (pageNumber * this.pagination.pageSize < total) {
        return true;
      }
      return false;
    },
    hasBeforePage() {
      const pageNumber = this.pagination.current;
      if (pageNumber > 1) {
        return true;
      }
      return false;
    },
    handleTableChange(pagination, _, sorter) {
      this.pagination = pagination;
      this.sorter.sort_field = sorter.field;
      this.sorter.sort = sorter.order === 'ascend' ? 'asc' : 'desc';
      this.getCaseList();
    },
    close() {
      this.caseId = null;
      this.caseData = {};
      this.detailVisible = false;
      this.getCaseList();
      this.$emit('refresh-detail'); // 通知父组件刷新
    },
    // 获取用例列表
    getCaseList() {
      this.loading = true;
      planRelatedCases({
        ...this.filterForm,
        ...this.sorter,
        tester: this.filterForm.tester.length > 0 ? this.filterForm.tester : null,
        result: this.filterForm.result.length > 0 ? this.filterForm.result : null,
        test_plan_id: this.planId,
        page_number: this.pagination.current,
        page_size: this.pagination.pageSize
      })
        .then(res => {
          this.tableData = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getCaseListPromise() {
      return planRelatedCases({
        ...this.filterForm,
        ...this.sorter,
        tester: this.filterForm.tester.length > 0 ? this.filterForm.tester : null,
        result: this.filterForm.result.length > 0 ? this.filterForm.result : null,
        project_id: this.projectId,
        test_plan_id: this.planId,
        page_number: this.pagination.current,
        page_size: this.pagination.pageSize
      });
    },
    loadNextCase() {
      if (this.nextCaseId != null) {
        if (this.nextCaseId !== -1) {
          this.caseId = this.nextCaseId;
          this.findNextCase();
          this.findBeforeCase();
        } else {
          this.pagination.current += 1;
          if (this.pagination.current > Math.ceil(this.pagination.total / this.pagination.pageSize)) {
            return;
          }
          this.getCaseListPromise().then(res => {
            this.tableData = res.data.items;
            if (this.tableData.length > 0) {
              this.caseId = this.tableData[0].id;
            }
            this.findNextCase();
            this.findBeforeCase();
          });
        }
      }
    },
    loadBeforeCase() {
      if (this.beforeCaseId != null) {
        if (this.beforeCaseId !== -1) {
          this.caseId = this.beforeCaseId;
          this.findNextCase();
          this.findBeforeCase();
        } else {
          this.pagination.current -= 1;
          this.getCaseListPromise().then(res => {
            this.tableData = res.data.items;
            if (this.tableData.length > 0) {
              this.caseId = this.tableData[this.tableData.length - 1].id;
            }
            this.findNextCase();
            this.findBeforeCase();
          });
        }
      }
    },
    // 处理检查需求提审条件，只做消息传递
    handleCheckRequirementReview(data) {
      // 向父组件传递事件
      this.$emit('check-requirement-review', data);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .customer-filter {
  .ant-page-header {
    padding: 0;
  }

  .ant-form-item {
    margin-bottom: 8px;
    display: inline-block !important;

    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }

  .filter-right {
    float: right;
    text-align: right;
  }

  .customer-date-picker {
    width: calc(50% - 3px);
  }
}

/deep/ .ant-table-tbody > tr > td {
  padding: 8px 8px;
}
/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 0;
}

/deep/ .ant-table-thead > tr > th {
  padding: 8px 8px;
}

.handle-menu {
  margin: 0 4px;
}

.custom-link {
  color: rgba(0, 0, 0, 0.65);
}

.custom-link:hover {
  color: #1890ff;
}

.handle-button {
  margin-left: 8px;
}
</style>
